export default __webpack_public_path__ + "static/media/concept-nova-logo.78c6aedf.jpg";